export default __webpack_public_path__ + "curve-section-top.9ccfe3.svg";